import React, { ReactNode } from 'react';
import { style } from 'typestyle';
import { Footer } from '@src/components/Footer';
import backgroundLoginImg from '@src/assets/img/site/background-login.jpg';

interface LoginContainerProps {
  children: ReactNode;
}

export function LoginContainer({ children }: LoginContainerProps) {
  return (
    <div className={loginClass}>
      <div className={contentClass}>
        {children}
      </div>
      <Footer />
    </div>
  );
}

const loginClass = style({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  backgroundImage: `url(${backgroundLoginImg})`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  textAlign: 'center',
  overflowY: 'scroll',
  $nest: {
    '& .alert-success': {
      backgroundColor: '#50a92b !important',
    },
  },
});

const contentClass = style({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'center',
  flexDirection: 'column',
});
